import { motion, useScroll, useTransform } from "framer-motion";
import "../styles/queen.css";
import queen from "../assets/images/WQueen.png";
import { useSpring } from "framer-motion";


export default function Queen() {
  const { scrollY } = useScroll(); 

  
  const x=useTransform(scrollY,[0,248,850,1620],[0,1250,700,1250])
  const y=useTransform(scrollY,[0,248,850],[0,400,250])
  
  const smoothX = useSpring(x, { stiffness: 70, damping: 15 });
  const smoothY = useSpring(y, { stiffness: 70, damping: 15 });
  const rotate = useTransform(scrollY, [0,248,500,850,1200,1620], [0,360,360,0,0,360]);
  const opacity = useTransform(scrollY, [0, 150], [0, 1]); // fade in at start

  return (
    <motion.div
      className="queen-float"
      style={{ x: smoothX,y:smoothY,rotate,opacity}}
    >
      <img src={queen} alt="queen" />
    </motion.div>
  );
}
